import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function() {};
    window.console.warn = function() {};
    window.console.error = function() {};
  }
}

platformBrowserDynamic().bootstrapModule(AppModule);
